<template>
  <div>
    <LeftSidebar
      :visible="visible"
      :title="$lang.executePlan"
      bodyClass="padding-y-16 overflow-y-hidden"
      titleClass="padding-x-16"
      :width="700"
      @close="handleClose"
    >
      <template>
        <ListWrapper
          v-if="visible"
          :url="url"
          :hasTitle="false"
          :hasAddButton="false"
          :isUseInSidebar="true"
          menuBarClass="padding-x-16"
          searchTxtClass="width-percent-100"
          @getPermissions="getPermissions"
          @getLoading="getLoading"
        >
          <template slot-scope="{ items }">
            <LoadingWrapper :loading="loading">
              <template #loading>
                <Loading :count="10" />
              </template>
              <template #default>
                <b-row class="margin-0 padding-x-16">
                  <b-col
                    v-for="(item, index) in generateItems(items)"
                    :key="index"
                    cols="12"
                    class="border--solid border--complementary-50 border-radius-8 padding-x-12 padding-y-8 margin-bottom-8"
                  >
                    <b-row class="margin-0">
                      <b-col cols="12" md="6">
                        <div
                          class="font-size-14 color-complementary-400 text-ellipsis"
                        >
                          {{ item.plan }}
                        </div>
                        <div class="font-size-12 color-complementary-300">
                          <span>{{ $lang.start }}: {{ item.startTime }}</span>
                          <span class="color-complementary-100"> | </span>
                          <span>{{ $lang.end }}: {{ item.endTime }}</span>
                        </div>
                        <div class="font-size-12 color-complementary-300">
                          {{ $lang.room }}: {{ item.roomName }}
                        </div>
                      </b-col>
                      <b-col cols="12" md="6">
                        <AvatarGroup
                          :data="item.candidateData"
                          deskTopPopupClass="top-200"
                          :hasProfilePopup="false"
                        />
                        <AvatarGroup
                          :data="item.assessorsData"
                          deskTopPopupClass="top-200"
                          :hasProfilePopup="false"
                        />
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </template>
            </LoadingWrapper>
          </template>
        </ListWrapper>
      </template>
    </LeftSidebar>
  </div>
</template>

<script>
import { LeftSidebar, AvatarGroup } from "@/components/re-design";
import { ListWrapper, LoadingWrapper } from "@/components/re-design/";
import Loading from "./Loading.vue";
import { pathOr } from "ramda";
import { generateApiUrl } from "@/shared/utils";
import { computed, ref, toRefs } from "vue";

export default {
  components: {
    LeftSidebar,
    AvatarGroup,
    ListWrapper,
    LoadingWrapper,
    Loading,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    id: {
      type: [Number, String],
      default: null,
    },
  },
  setup(props, { emit }) {
    // generate props data
    const { visible, id } = toRefs(props);

    const handleClose = () => emit("handleClose");

    const url = computed(() =>
      generateApiUrl(["kanoon", "center_execute_plan_id"], [id.value])
    );
    const permissions = ref([]);
    const getPermissions = (value) => (permissions.value = [...value]);
    const generateItems = (items) => {
      return items.map((item) => {
        const candidateName = pathOr("", ["candidate", "full_name"], item);
        const candidateNumber = pathOr(
          "",
          ["candidate", "candidate_number"],
          item
        );
        const candidateData = {
          type: "شرکت کننده",
          id: candidateNumber,
          name: candidateName,
          images: [pathOr("", ["candidate", "img"], item)],
        };
        const candidateUserItem = {
          full_name: candidateName,
          person_code: item.secondPersonCode,
          parvandeh_code: item.secondPersonParvandehCode,
          image_address: pathOr("", ["candidate", "img"], item),
        };

        const assessor = pathOr(null, ["assessor"], item);
        const assessorName = pathOr("", ["full_name"], assessor);
        const secondAssessor = pathOr(null, ["second_assessor"], item);
        const secondAssessorName = pathOr("", ["full_name"], secondAssessor);

        const assessorsData = {
          type: "ارزیاب",
          id: pathOr("", ["assessor_number"], assessor),
          name: secondAssessorName
            ? `${assessorName} - ${secondAssessorName}`
            : assessorName,
          images: [
            pathOr("", ["img"], assessor),
            pathOr("", ["img"], secondAssessor),
          ],
        };

        return {
          plan: pathOr("", ["plan"], item),
          startTime: pathOr("", ["start_time"], item),
          endTime: pathOr("", ["end_time"], item),
          startDate: pathOr("", ["start_date"], item),
          roomName: pathOr("", ["room_name"], item),
          candidateData,
          assessorsData,
        };
      });
    };

    const loading = ref(false);
    const getLoading = (value) => (loading.value = value);

    // return data to be used in template
    return {
      visible,
      url,
      handleClose,
      generateItems,
      getPermissions,
      loading,
      getLoading,
    };
  },
};
</script>
